import { Button, Link } from '@change/ds-core-ui/next';

import type { StarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import type { FullPostType, PostPreviewSizes } from 'src/app/pages/starterDashboardV2/shared/components';
import { PostPreview } from 'src/app/pages/starterDashboardV2/shared/components';
import { useIsMobile } from 'src/app/shared/hooks/userAgent';

type Props = {
	onClick?: () => void;
	fullPostType: FullPostType;
	petition: StarterDashboardV2PageData['petition'];
	disabled: boolean;
	sharingResource: {
		previewImageUrl: string;
		message: string;
		petitionTitle: string;
	};
	previewSize: PostPreviewSizes;
};

const CTA_MAP: Record<FullPostType, string> = {
	facebook_post: 'Post on Facebook feed',
	facebook_group_post: 'Post on Facebook group',
	facebook_story: 'Post on Facebook story',
	instagram_post: 'Post on Instagram feed',
	instagram_story: 'Post on Instagram story',
	reddit_post: 'Post on Reddit',
	reddit_group_post: 'Post on Reddit',
};

export function PostPreviewCard(props: Props) {
	const { fullPostType, onClick, petition, sharingResource, disabled, previewSize } = props;
	const isMobile = useIsMobile();

	const ctaCopy = disabled ? 'Share from your phone' : CTA_MAP[fullPostType];

	return (
		<section
			key={fullPostType}
			className="flex gap-3"
			data-testid={`${fullPostType}-post-card`}
			aria-label={fullPostType}
		>
			<div className="flex flex-col gap-3 gap-y-6">
				<Link
					data-qa="post-preview-container"
					disabled={disabled}
					onClick={onClick}
					href="#"
					variant="secondary"
					className="no-underline"
					underline={false}
					aria-disabled={disabled}
					aria-label={`Start Sharing Flow for ${fullPostType}`}
				>
					<PostPreview
						variant={fullPostType}
						sharingResource={sharingResource}
						size={previewSize}
						loading={false}
						showPlatformIcon
						data-testid={`${fullPostType}-post-preview`}
						petition={petition}
						disabled={disabled}
					/>
				</Link>
				<Button
					onClick={onClick}
					variant={disabled ? 'tertiary' : 'secondary'}
					size={isMobile ? 'x-small' : 'small'}
					disabled={disabled}
					data-qa={`${fullPostType}-share-button`}
					data-testid={`${fullPostType}-share-button`}
					aria-label={ctaCopy}
					className="w-full min-w-[140px] no-underline md:min-w-0"
				>
					{ctaCopy}
				</Button>
			</div>
		</section>
	);
}
